// extracted by mini-css-extract-plugin
module.exports = {"preloader":"styles_preloader__2AWDi","loader":"styles_loader__2ijc3","line":"styles_line__3lPC5"};